import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import Badge from "@mui/material/Badge";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import { Button } from "react-bootstrap";
import { handleExportClick } from "../exportFile.js";
import { Checkbox, Modal } from "antd";
import ReactToPrint from "react-to-print";
import Trips from "../reports/Trips.js";
import ActionButtons from "./TripsActionButton.js";



import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { 
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import {  useNavigate } from 'react-router-dom';


const TripsList = () => {
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);
  const [trips, setTrips] = useState([]);
  let [loading, setLoading] = useState(true);
  const getTrips = async () => {
    const response = await axios
      .get("trips/")
      .then((res) => {
        const tripsWithMergedNames = res.data.map((transaction) => {
          const passengerName = `${transaction.passenger?.firstName} ${transaction.passenger?.lastName}`;
          const driverName = `${transaction.driver?.firstName} ${transaction.driver?.lastName}`;

          return {
            ...transaction,
            passenger: { ...transaction.passenger, name: passengerName },
            driver: { ...transaction.driver, name: driverName },
          };
        });

        setTrips(tripsWithMergedNames);
        setLoading(false);
        //notify()
      })
      .catch((err) => {
        notifyError();
      });

    console.log("==========trips===============", response);
  };

  const edit = "trip";
  const detail = "viewTrip";

  const notify = () =>
    toast.success("Trips list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    getTrips();
  }, []);


  const navigate = useNavigate();


  const columns = React.useMemo(
    () => [
      {
        Header: "Passenger Information ",
        columns: [
          {
            Header: "ID",
            accessor: "id",
          },
          {
            Header: "First Name",
            accessor: "passenger.firstName",
          },
          {
            Header: "Last Name",
            accessor: "passenger.lastName",
          },
          {
            Header: "Phone Number",
            accessor: "passenger.phoneNumber",
          },
        ],
      },
      {
        Header: "Driver Information",
        columns: [
          {
            Header: "First Name",
            accessor: "driver.firstName",
          },
          {
            Header: "Last Name",
            accessor: "driver.lastName",
          },
          {
            Header: "Phone Number",
            accessor: "driver.phoneNumber",
          },

          {
          Header: "Status",
          accessor: "status",
          disableFilters: true,
          Cell: (row) => {
            const status = row.cell.row.original.status || "Active";
            return (
              <Chip 
                label={status} 
                color={status === "Active" ? "success" : "warning"}
                variant="filled"
                sx={{
                  fontWeight: 'bold',
                  borderRadius: '8px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  boxShadow: status === "Active" 
                    ? '0 2px 4px rgba(0,255,0,0.2)' 
                    : '0 2px 4px rgba(255,165,0,0.2)'
                }}
              />
            );
          },
        },

        {
          Header: "End Reason",
          accessor: "TripRequest.endReason",
          disableFilters: true,
          Cell: (row) => {
            const endReason = row.cell.row.original.TripRequest?.endReason;
            
            if (!endReason) {
              return (
                <span style={{ color: '#9ca3af', fontStyle: 'italic', fontSize: '0.85rem' }}>
                  N/A
                </span>
              );
            }
            
            return (
              <Tooltip title={endReason} placement="top">
                <span style={{ 
                  display: 'block',
                  maxWidth: '200px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  cursor: 'pointer',
                  color: '#374151',
                  fontSize: '0.9rem'
                }}>
                  {endReason}
                </span>
              </Tooltip>
            );
          },
        },

          {
            Header: "Action",
            accessor: "action",
            disableFilters: true,
            Cell: (row) => (
              <div>
                {role.filter(function (e) {
                  return e.perm_name === "list_all_trips";
                }).length > 0 && (
                  

              <Tooltip title="View all_trips">
              <span>
                <VisibilityIcon 
                  color="success" 
                  sx={{ 
                    cursor: 'pointer',
                    transition: 'transform 0.2s',
                    '&:hover': {
                      transform: 'scale(1.2)',
                      color: '#16a34a'
                    }
                  }}
                  onClick={() => navigate(`/tripDetail/${row.cell.row.original.id}`)}
                />
              </span>
              </Tooltip>
                )}
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  const columns_expo = React.useMemo(
    () =>
      [
        {
          columns: [
            {
              Header: "Id",
              accessor: "id",
            },
          ],
        },
        {
          Header: "Passenger",
          columns: [
            { Header: "Passenger Name", accessor: "passenger.name" },
            // { Header: "Last Name", accessor: "passenger.lastName" },
            { Header: "Passenger Phone", accessor: "passenger.phoneNumber" },
          ],
        },
        {
          Header: "Driver",
          columns: [
            { Header: "Driver Name", accessor: "driver.name" },
            // { Header: "Last Name", accessor: "driver.lastName" },
            { Header: "Driver Phone", accessor: "driver.phoneNumber" },
          ],
        },
        {
          Header: "Other",
          columns: [{ Header: "Date", accessor: "createdAt" }],
        },
      ].flatMap((group) => group.columns),
    []
  );

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [selectedColumns, setSelectedColumns] = useState(
    columns_expo.map((column) => column.Header)
  );

  const handleOkModal = () => {
    console.log("handleOkModal called");
    setIsModalVisible(false);
    handleExportClick(
      trips,
      columns_expo,
      "Trips",
      "trips.pdf",
      selectedColumns
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // Inside your component
  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prevSelectedColumns) => {
      if (prevSelectedColumns.includes(columnHeader)) {
        return prevSelectedColumns.filter((col) => col !== columnHeader);
      } else {
        return [...prevSelectedColumns, columnHeader];
      }
    });
  }
  const printableRef = useRef(null);

  const prRef = useRef(null);
  const [isPrintableComponentVisible, setIsPrintableComponentVisible] =
    useState(false);

  const handlePrintButtonClick = () => {
    setIsPrintableComponentVisible(true);
  };
  return (
    <div className="content-wrappers" style={{ marginTop: '-40px' }}>
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="content" ref={printableRef}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                {/* <div className="card-header"> */}
                  
                  <ActionButtons title="Trips"  showModal={showModal}/>

                  <Modal
                   style={{marginTop: "60px"}} 
                    title="Select Columns to Export"
                    visible={isModalVisible}
                    onOk={handleOkModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button
                        style={{ marginLeft: "10px" }}
                        key="ok"
                        type="primary"
                        onClick={handleOkModal}
                      >
                        OK
                      </Button>,
                    ]}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      {columns_expo.map((column) => (
                        <div
                          key={column.Header}
                          style={{ marginBottom: "10px" }}
                        >
                          <Checkbox
                            checked={selectedColumns.includes(column.Header)}
                            onChange={() => handleColumnToggle(column.Header)}
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          >
                            {column.Header}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Modal>
                {/* </div> */}

                <div className="card-body">
                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}
                  {!loading && (
                    <Table
                      columns={columns}
                      data={trips}
                      edit={edit}
                      detail={detail}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
    </div>
  );
};

export default TripsList;
